import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getHomepagePageData } from './api';
import type { HomepagePageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: HomepagePageDataContext,
	Provider: HomepagePageDataContextProvider,
	useContext: useHomepagePageData,
	useAsyncData: useHomepagePageDataFromApi,
	prefetchAsyncData: prefetchHomepagePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'HomepagePageDataContext',
	dataProperty: 'pageData',
	getData: getHomepagePageData,
	hookDeps: ({ locale, countryCode, isBot }) => [locale, countryCode, isBot],
	getUniqueId: ({ locale, countryCode, isBot }) => `${locale}:${countryCode}:${isBot ? 'bot' : 'user'}`,
	errorHandler: pageDataErrorHandler<HomepagePageDataErrorCode>(),
});
